export const topScrol = () => {
  const trigger = document.getElementById('scroll-trigger');
  const topScrolBtn = document.querySelector('.top-scrol');

  if (!trigger || !topScrolBtn) return;

  topScrolBtn.classList.remove('top-scrol--visible');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          topScrolBtn.classList.remove('top-scrol--visible');
        } else {
          topScrolBtn.classList.add('top-scrol--visible');
        }
      });
    },
    {
      threshold: 0,
      rootMargin: '0px',
    }
  );

  observer.observe(trigger);
};
